import {
    Autocomplete,
    type AutocompleteProps,
    type AutocompleteRenderInputParams,
    FormControl,
    FormLabel,
    TextField
} from "@mui/material";
import React, {type SyntheticEvent, useEffect, useState} from "react";
import type {GroupDataDto} from "@/global/api/gen/ts/GroupDataDto";

type Props<T> = {
    onChange: (value: T | null) => void;
    message?: string;
    groupInfo: GroupDataDto,
    options: T[];
    label?: string;
    placeholder?: string;
    getOptionLabel: (option: T) => string;
    defaultId?: number | null;
    isLoading: boolean;
} & Omit<AutocompleteProps<T, false, boolean, false>, 'options' | 'onChange' | 'renderInput'>

export function BaseAutocomplete<T>({onChange, groupInfo, defaultId, isLoading, getOptionLabel, options, message, label, placeholder, ...props}: Props<T>) {
    const [value, setValue] = useState<T  | null>(null);

    useEffect(() => {
        if (!defaultId) {
            setValue(null);
        }
    }, [defaultId]);

    const renderInput = (params: AutocompleteRenderInputParams) => {
        return (
            <FormControl fullWidth>
                <FormLabel>
                    {label}
                </FormLabel>
                <TextField
                    {...params}
                    error={!!message}
                    placeholder={placeholder}
                    helperText={message}
                />
            </FormControl>
        );
    };

    const handleChange = (_: SyntheticEvent, newValue: T | null) => {
        setValue(newValue);
        onChange(newValue);
    };

    return (
        <Autocomplete
            value={value}
            fullWidth
            onChange={handleChange}
            renderInput={renderInput}
            options={options}
            getOptionLabel={getOptionLabel}
            loading={isLoading}
            noOptionsText="Нет подходящих элементов"
            {...props}
        />
    );
}